module.exports = __webpack_public_path__ + "images/logo-dark@2x-385a6108010c8bb7de4a0c716f4f7764.png";